import { createContext, useContext } from 'react';

// Create the context with a default value
export const CanvasContext = createContext({
  context: undefined,
});

// Custom hook to use the CanvasContext
export const useCanvasContext = () => {
  return useContext(CanvasContext);
};
